import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { useSetOrderIdCtx } from '~shared/segments/Order';
import { usePersistence } from './usePersistence';

/**
 * Returns the `resetPersistence` callback, that removes the data, used to create
 * and submit the order, that are no longer useful.
 */
export var useResetPersistence = function useResetPersistence() {
  var _useSetOrderIdCtx = useSetOrderIdCtx(),
      clearOrder = _useSetOrderIdCtx.clearOrder;

  var reset = useResetPersistenceNoOrderContext();
  var resetPersistence = React.useCallback(function (options) {
    reset({
      clearOrder: clearOrder,
      //
      withAuth: options === null || options === void 0 ? void 0 : options.withAuth
    });
  }, [clearOrder, reset]);
  return resetPersistence;
};
/**
 * Returns the `resetPersistence` callback, that removes the data, used to create
 * and submit the order, that are no longer useful.
 * This version of the hook can be used directly inside of the `OrderProvider`.
 */

export var useResetPersistenceNoOrderContext = function useResetPersistenceNoOrderContext() {
  var _usePersistence = usePersistence({
    key: "auth"
  }),
      _usePersistence2 = _slicedToArray(_usePersistence, 3),
      clearAuth = _usePersistence2[2];

  var resetPersistence = React.useCallback(function (_ref) {
    var clearOrder = _ref.clearOrder,
        withAuth = _ref.withAuth;
    clearOrder();

    if (withAuth) {
      clearAuth();
    }
  }, [clearAuth]);
  return resetPersistence;
};